import type {
  FreeToPlayTeaserPayload,
  ProductCatalogElement,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export const useFreeToPlay = () => {
  const isFreeToPlayTeaser = (teaser: ProductCatalogElement): teaser is FreeToPlayTeaserPayload =>
    teaser?.__typename === 'FreeToPlayTeaserPayload'

  return { isFreeToPlayTeaser }
}
